import defaults from '../content/defaults.json';

/**
 * Basisadresse der API. In der Produktion liegt sie unter /api auf derselben
 * Domain. Für die lokale Entwicklung kann REACT_APP_API_BASE auf einen
 * laufenden PHP-Server zeigen, z. B. http://localhost:8000/api
 */
const API_BASE = process.env.REACT_APP_API_BASE || '/api';

/** Ein Aufruf liefert alle Inhalte der Seite. */
export function fetchSite() {
  return fetch(`${API_BASE}/index.php?r=site`, {
    headers: { Accept: 'application/json' },
  }).then((response) => {
    if (!response.ok) {
      throw new Error(`API antwortete mit ${response.status}`);
    }
    return response.json();
  });
}

/**
 * Legt die gepflegten Inhalte über die im Code hinterlegten Standardwerte.
 * Fehlt ein Abschnitt im CMS, greift der Standard - die Seite bleibt also
 * auch dann vollständig, wenn das Backend nicht erreichbar ist.
 */
export function mergeSite(remote) {
  const safe = remote && typeof remote === 'object' ? remote : {};

  return {
    content: mergeSections(defaults.content, safe.content),
    media: mergeMedia(defaults.media, safe.media),
    events: mergeEvents(defaults.events, safe.events),
    instagram: safe.instagram && typeof safe.instagram === 'object'
      ? safe.instagram
      : { status: { connected: false, enabled: false }, items: [] },
  };
}

function mergeSections(base, override) {
  const result = {};
  const keys = new Set([...Object.keys(base || {}), ...Object.keys(override || {})]);

  keys.forEach((key) => {
    const baseSection = (base && base[key]) || {};
    const overrideSection = (override && override[key]) || {};
    // Flaches Zusammenführen genügt: die Abschnitte sind eine Ebene tief,
    // Listen sollen komplett ersetzt werden (sonst ließen sie sich nie leeren).
    result[key] = { ...baseSection, ...overrideSection };
  });

  return result;
}

function mergeMedia(base, override) {
  const result = { ...(base || {}) };
  Object.keys(override || {}).forEach((key) => {
    const list = override[key];
    // Eine leere Liste im CMS bedeutet: Slider bewusst geleert.
    if (Array.isArray(list)) {
      result[key] = list.filter((image) => image && image.src);
    }
  });
  return result;
}

function mergeEvents(base, override) {
  if (override && Array.isArray(override.months)) {
    return { months: override.months };
  }
  return base || { months: [] };
}

/** Die Standardinhalte, falls die API gar nicht antwortet. */
export const fallbackSite = mergeSite(null);
